import {Injectable} from '@angular/core';
import {TrackingService} from '@ox/data';
import {catchError, map, throwError} from 'rxjs';
import {AemDataService, ShopDataService} from '@webu/data';
import {OX_KEYS} from '@ox/config';
import {AppConfigService} from '@ox/utils';
import {BaseResponse, IBaseResponse, PricingDataItem} from '@ox/typings';

@Injectable()
export class PdpService {

  constructor(
    private shopDataService: ShopDataService,
    private trackingService: TrackingService,
    private aemDataService: AemDataService,
    private config: AppConfigService
  ) {}

  getJsonFile(product: string, variation?: string, year = '') {
    return this.aemDataService
      .getPdpJSON(
        this.config.bml.brand.toLocaleLowerCase(),
        product,
        this.config.bml.market.toLowerCase(),
        this.config.bml.lang.toLocaleLowerCase(),
        variation,
        year
      )
      .pipe(
        map(({data}) => {
          return {
            archetype: data.archetype,
            brand: data.brand,
            product: {
              productCode: data.products[0].productCode,
              templates: {
                name: data.products[0].templates[0].name,
                page: data.products[0].templates[0].page,
                pdpDesign: data.products[0].templates[0].pdpDesign,
                components: [...data.products[0].templates[0].components],
                allowIndex: data.products[0].templates[0].allowIndex
              }
            }
          };
        }),
        catchError((error: any) => {
          this.trackingService.trackEvent(
            'event25',
            'AEM.PDP.JSON.Unknown.Failure',
            ''
          );
          return throwError(() => new Error(error));
        }
        ));
  }

  getPricingData(isAuthenticated: boolean, planId: string, vin?: string) {
    const validResponse = map((res: IBaseResponse<BaseResponse<PricingDataItem>>) => (res?.data || res?.messages) ? res : (() => { throw new Error('Null Response'); })());
    if (isAuthenticated && vin)
      return this.shopDataService.getPricingData(planId, vin).pipe(validResponse,
        catchError((error) => this.catchPricingError(error)));
    else
      return this.shopDataService.getUnauthPricingData(planId).pipe(validResponse,
        catchError((error) => this.catchPricingError(error)));
  }

  catchPricingError(error: any) {
    let errorTrackingCode = '';
    if (error?.code && error?.subCode) {
      errorTrackingCode = `${error?.code}-${error?.subCode}`;
    }
    this.trackingService.trackEvent(
      'event25',
      OX_KEYS.PDP.ERROR.PRICING_API[errorTrackingCode]
    );
    return throwError(() => new Error(error));
  }
}
